'use client'
import { useTranslations } from 'next-intl'
import React, { useEffect, useRef, useState } from 'react'
import { ConstantService } from 'src/constants/apiPaths'
import { useParams } from 'next/navigation'
import { useGeoCodeAddress, useHomeList } from 'src/lib/api/homeService'
import { HelperService } from 'src/lib/api'
import { CompilerProvider } from 'src/lib/api/complierProvider'
import {union} from 'lodash';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const Slider = dynamic(() => import('react-slick'), { ssr: false });

import FleetsCardsSkeleton from './FleetsCardsSkeleton'
import FleetsCardsLayout from './FleetsCardsLayout'
import getSlickSettings from 'src/constants/slickSettings'
import dynamic from 'next/dynamic'
import FleetTabs from './FleetTabs'

const ChauffeurServicesFleet = ({
  isFleetByLocationPage = false,
  isHideTabs = false,
  searchedFleetData,
  changeCurrLoading,
  isShowRate = false,
  isShowSkeletonTabs,
  isElectricPage=false,
  tabsAlignment = 'left'
}) => {
  const helperService = new HelperService()
  const compilerProviderInst = new CompilerProvider(helperService)
  const t = useTranslations('all-fleet-types')
  const { city } = useParams()
  const [form, setForm] = useState({})
  const [data, setData] = useState({})
  const [activeTab, setActiveTab] = useState({ key: 'Business', index: 0 })
 
  const [hasInitialized, setHasInitialized] = useState(false)
  const checkCardsNumber = isHideTabs
    ? data.length
    : data[activeTab.key]?.length
  useEffect(() => {
    if ((searchedFleetData && isFleetByLocationPage) || (searchedFleetData && isElectricPage)) {
      setData(searchedFleetData)
    }
  }, [searchedFleetData])

  const sliderSettings = getSlickSettings(checkCardsNumber , 'default')
  const { geoData, error, isLoading } = useGeoCodeAddress(city || 'london')
  const { fetchHomeList, loading } = useHomeList(form)

  const currencyList = ConstantService.currency
  const selectedCurrency = currencyList[0]
 

  useEffect(() => {
    const initializeData = async () => {
      if (geoData && !hasInitialized && !isFleetByLocationPage && !isElectricPage) {
        setHasInitialized(true)

        setForm({
          address: geoData.results[0]?.formatted_address,
          currency: selectedCurrency.value,
        })


        try {
          const fetchedData = await fetchHomeList()
          const homeData = compilerProviderInst.constructHomeData(
            fetchedData.data
          )
          const chauffeurGroups = helperService.groupBy(
            homeData.Chauffeur,
            'type'
          )

          const sortedChauffeurGroup = {
            Business: union(
              chauffeurGroups['business'],
              chauffeurGroups['standard']
            ),
            First: union(
              chauffeurGroups['executive'],
              chauffeurGroups['first']
            ),
            Electric: chauffeurGroups['electric'],
            Luxe: chauffeurGroups['luxe'],
            SUV: chauffeurGroups['suvs'],
            Minivan: union(
              chauffeurGroups['plus'],
              chauffeurGroups['minivan']
            ),
            Van: chauffeurGroups['van'],
            Minibus: chauffeurGroups['minibus'],
            Coach: chauffeurGroups['coach'],
            // Limousine: chauffeurGroups['limousine'],
            Armoured: chauffeurGroups['armoured'],
          }

          setData(sortedChauffeurGroup)
          // setHorizontalScrollPercentage(sortedChauffeurGroup)
        } catch (error) {
          console.error('Error fetching home list:', error)
        }
      }
    }

    initializeData()
  }, [
    geoData,
    selectedCurrency.value,
    hasInitialized,
    fetchHomeList,
    helperService,
    // horizontalScrollPercentage,
  ])

 
  
  return Object.keys(data).length ? (
    <div className={` ${isElectricPage ? 'electric-page' : ''} w-full max-w-full min-h-[300px]`}>
     <FleetTabs isHideTabs={isHideTabs}  tabsAlignment={tabsAlignment} data={data} activeTab={activeTab} setActiveTab={setActiveTab} />
      <Slider {...sliderSettings}>
        {!isFleetByLocationPage && !isElectricPage
          ? data[activeTab.key]?.map((item, index) => (
              <FleetsCardsLayout changeCurrLoading={changeCurrLoading} item={item} key={item.name + index} index={index} 
              activeTab={activeTab}
              isShowRate={isShowRate}
              isHideTabs={isHideTabs}
              isHourlyRate ={true}
              />
            ))
          : data?.map((item, index) => 
            {
            return (
              <FleetsCardsLayout
                item={item}
                key={item.name + index}
                index={index}
                activeTab={activeTab}
                changeCurrLoading={changeCurrLoading}
                isShowRate={isShowRate}
              isHideTabs={isHideTabs}
              isHourlyRate ={true}
              />
            )})}
      </Slider>
    </div>
  ) : (
    <FleetsCardsSkeleton tabsAlignment={tabsAlignment} isShowSkeletonTabs={isShowSkeletonTabs} />
  )
}

export default ChauffeurServicesFleet
